"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVideoContentStyle;

function createVideoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    height: videoHeight,
    width: '100%'
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvVmlkZW9Db250ZW50LnRzIl0sIm5hbWVzIjpbImNyZWF0ZVZpZGVvQ29udGVudFN0eWxlIiwidmlkZW9IZWlnaHQiLCJoZWlnaHQiLCJ3aWR0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUVlLFNBQVNBLHVCQUFULE9BQXNFO0FBQUEsTUFBbkNDLFdBQW1DLFFBQW5DQSxXQUFtQztBQUNuRixTQUFPO0FBQ0xDLElBQUFBLE1BQU0sRUFBRUQsV0FESDtBQUVMRSxJQUFBQSxLQUFLLEVBQUU7QUFGRixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFN0cmljdFN0eWxlT3B0aW9ucyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVZpZGVvQ29udGVudFN0eWxlKHsgdmlkZW9IZWlnaHQgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgaGVpZ2h0OiB2aWRlb0hlaWdodCxcbiAgICB3aWR0aDogJzEwMCUnXG4gIH07XG59XG4iXX0=